import { UI } from '../../tokens';

// Shared, lightly-refreshed styling for the Progress task tables (node + edge): a clean
// white card with a soft shadow, an uppercase tinted sticky header and roomy hoverable
// rows. Kept close to the original look — just fresher.
export const progressTableContainerSx = {
  backgroundColor: UI.surface,
  borderRadius: UI.radiusCard,
  border: `1px solid ${UI.border}`,
  boxShadow: '0 1px 3px rgba(26,36,45,0.08)',
  marginX: 1,
  width: 'auto',
  maxHeight: 400,
};

export const progressHeaderCellSx = {
  fontWeight: 700,
  fontSize: 12,
  textTransform: 'uppercase',
  letterSpacing: 0.4,
  color: UI.textPrimary,
  backgroundColor: UI.surfaceMuted,
  borderBottom: `1px solid ${UI.border}`,
  whiteSpace: 'nowrap',
};

// Applied to the <Table> so every body cell gets the fresher type + divider at once.
// `whiteSpace: nowrap` lets each column widen to fit its content (the container scrolls
// horizontally) instead of cramming labels/values onto two lines.
export const progressTableSx = {
  '& .MuiTableCell-root': {
    px: 2.5,
    whiteSpace: 'nowrap',
  },
  '& .MuiTableCell-body': {
    fontSize: 13,
    color: UI.textPrimary,
    borderBottom: `1px solid ${UI.border}`,
  },
};

export const progressBodyRowSx = {
  transition: 'background-color .15s ease',
  '&:hover': { backgroundColor: UI.surfaceMuted },
  '&:last-child td, &:last-child th': { border: 0 },
};
